/**
 *
 * @param {PropertyValueProps} value
 * @param {String} initial
 * @param {Boolean} isFn
 * @param {Boolean} isCalc
 */
const getCurrentInitialValue = (value, initial, isFn, isCalc) => {
  if (isCalc) {
    const name = /** @type {String} */ (value.get("v_name"));
    const output = value.get("v_output");

    return `${name}(${output})`;
  } else if (isFn) {
    const array = [];
    const divider = /** @type {String} */ (value.get("v_divider"));
    const name = /** @type {String} */ (value.get("v_name"));
    const values = /** @type {Array<PropertyValueProps>} */ (
      value.get("v_values")
    );

    for (const value of values) {
      array.push(value.get("v_output"));
    }

    return `${name}(${array.join(divider)})`;
  } else {
    return initial;
  }
};

export default getCurrentInitialValue;
